<template>
    <div>
        <div class="flex flex-column">
            <label for="fieldLabel" class="mb-2" :class="{ 'font-bold': bold }">{{ fieldLabel }}:</label>
            <MultiSelect
                class="multiselect-custom"
                :class="{ 'p-invalid': props.errorMessage, 'square-chips': props.squaredChips }"
                v-model="fieldValue"
                :options="options"
                :optionLabel="optionLabel"
                :optionValue="optionValue"
                :filter="filter"
                :placeholder="placeholderLabel(label)"
                :display="displayType"
                @change="updateSelectedValue"
                :disabled="props.disabled"
            />
            <small class="p-invalid" v-if="props.errorMessage"> {{ props.errorMessage }}</small>
        </div>
    </div>
</template>
<script setup>
import { ref, defineProps, onMounted, computed, defineEmits, watch } from 'vue';
import { placeholderLabel } from '../../utilities/index.js';
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: Array,
    },
    label: {
        type: String,
    },
    options: {
        type: Array,
        default: () => [],
    },
    optionLabel: {
        type: String,
        default: 'name',
    },
    optionValue: {
        type: [Number, String],
        default: 'id',
    },
    errorMessage: {
        type: String,
    },
    displayType: {
        type: String,
        default: 'chip',
    },
    customStyle: {
        type: Boolean,
        default: false,
    },
    squaredChips: {
        type: Boolean,
        default: false,
    },
    bold: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    filter: {
        type: Boolean,
        default: true,
    },
});

// state
const fieldValue = ref([]);

const propsModelValue = computed(() => {
    return props.modelValue;
});

onMounted(() => {
    if (propsModelValue.value) {
        fieldValue.value = propsModelValue.value;
    }
});

const fieldLabel = computed(() => {
    return props.label ?? null;
});

watch(propsModelValue, () => {
    fieldValue.value = propsModelValue.value;
});

const updateSelectedValue = () => {
    emit('update:modelValue', fieldValue.value);
};
</script>
<style scoped lang="scss">
::v-deep(.multiselect-custom-virtual-scroll .p-multiselect) {
    min-width: 20rem;
}
::v-deep(.square-chips .p-multiselect-label-container .p-multiselect-label .p-multiselect-token) {
    padding: 0.25rem 0.5rem !important;
    border-radius: 3px !important;
    display: inline-flex !important;
    margin-right: 0.5rem !important;
    background-color: var(--primary-color) !important;
    color: var(--primary-color-text) !important;
}
</style>
